import { render, staticRenderFns } from "./EscuelasDetalle.vue?vue&type=template&id=367cc160&"
import script from "./EscuelasDetalle.vue?vue&type=script&lang=js&"
export * from "./EscuelasDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports